import { type ReactNode } from "react";

interface DetailFieldProps {
  label: string;
  value: ReactNode;
}

/**
 * Read-only label-above-value pair used by the Case Details pane.
 *
 * @param props.label - Field label shown above the value
 * @param props.value - Field value, or a node when extra decoration is needed
 */
const DetailField = (props: DetailFieldProps) => (
  <div className="flex min-w-0 flex-col gap-1">
    <div className="m-0 text-tiny font-semibold text-primaryGray-9">
      {props.label}
    </div>
    <div className="text-tiny leading-tiny text-primaryGray-1">
      {props.value}
    </div>
  </div>
);

export default DetailField;
